import { z } from 'zod';
import { ApplicationReviewStatus } from '../../graphql/operations';

export const applicationReviewStatusSchema = z.nativeEnum(
  ApplicationReviewStatus
);
